import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { getProductsBySeller } from '@/data/api/request/productsBySellerRequests';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useGetProductsBySeller(page: number) {
  const { showSnackError } = useSnackbarContext();
  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.catalog.sellerProductList, { page }],
    queryFn: () => getProductsBySeller({ pageNumber: page }),
  });

  useEffect(() => {
    if (error) showSnackError('Error al obtener productos del vendedor');
  }, [error]);

  return {
    data,
    error,
    isLoading,
  };
}
